import React, { useState, useMemo } from "react";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Posts from "./pages/Posts/Posts.jsx";
import About from "./pages/About/About.jsx";
import Contacts from "./pages/Contact/Contacts.jsx";
import Home from "./pages/Home/Home.jsx";
import FAQ from "./pages/FAQ/FAQ.jsx";
import NOTFOUND from "./pages/NOTFOUND.jsx";
import Postdetail from "./pages/Posts/postdetail.jsx";
import AdminLogin from "./pages/CMD/AdminLogin.jsx";
import Dashboard from "./pages/CMD/Dashboard.jsx";
import { AuthProvider } from "./pages/CMD/AuthContext"; // Import the AuthProvider
import Portfolio from "./pages/Portifolioo/Portfolioo.jsx";
import ProtectedRoute from "./pages/CMD/ProtectRoute.jsx";
import Projectdetail from "./pages/Portifolioo/Projectdetail.jsx";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ProtectedRoute2 from "./pages/CMD/ProtectedRoute2.jsx";
import Teampage from "./pages/TEAM/Teampage.jsx";
import TeamComponent from "./pages/TEAM/teamcomponent.jsx";
import { Analytics } from "@vercel/analytics/react"
function App() {
  const [mode, setmymode] = useState(
    localStorage.getItem("currentMode") || "light"
  );

  const darkTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode,
        },
      }),
    [mode]
  );

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND setmymode={setmymode} mode={mode} />,
    },
    {
      path: "/home",
      element: <Home setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/portfolio",
      element: <Portfolio setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <Dashboard setmymode={setmymode} mode={mode} />
        </ProtectedRoute>
      ),
      errorElement: <NOTFOUND />,
    },
    {
      path: "/faq",
      element: <FAQ mode={mode} setmymode={setmymode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/Team",
      element: <Teampage mode={mode} setmymode={setmymode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/admin",
      element:(
      <ProtectedRoute2>
        <AdminLogin setmymode={setmymode} mode={mode} />
        </ProtectedRoute2>
        ),
      errorElement: <NOTFOUND />,
    },
    {
      path: "/posts",
      element: <Posts setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
     {
      path: "/TeamMember/:memberId",
      element: <TeamComponent setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/about",
      element: <About setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "posts/:id",
      element: <Postdetail setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "portfolio/:id",
      element: <Projectdetail setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
    {
      path: "/contacts",
      element: <Contacts setmymode={setmymode} mode={mode} />,
      errorElement: <NOTFOUND />,
    },
  ]);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AuthProvider>
        <RouterProvider router={router} />
        <Analytics/>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
